import React from "react";
import globals from "../Globals";
import requests from "../Auth/Requests";
import { enqueueSnackbar, closeSnackbar } from "notistack";
import { Page } from "../Layout/PageLayout";

import {
    Box,
    Container,
    Paper,
    Typography,
    List,
    ListItemButton,
    ListItemText,
    Button,
    CircularProgress
} from "@mui/material";

export default class TitlesPage extends React.Component {
    state = {
        refreshing: false
    }

    onRefresh = () => {
        if (this.state.refreshing) return;

        const key = enqueueSnackbar("Refreshing roles...", {
            variant: "info",
            persist: true
        });

        this.setState({ refreshing: true });

        // Calls backend command `refresh` and expects a TitlesResponse payload
        requests.request("general refresh", {})
            .then(response => {
                globals.loginData.titles = response;
                try {
                    localStorage.setItem("login", JSON.stringify(globals.loginData));
                } catch (e) {
                    // ignore storage failures (quota/private mode)
                }
                closeSnackbar(key);
                enqueueSnackbar("Refresh successful!", { variant: "success" });
                this.forceUpdate();
            })
            .catch(error => {
                closeSnackbar(key);
                enqueueSnackbar(`Refresh failed: ${error.message}`, { variant: "error" });
            })
            .finally(() => {
                this.setState({ refreshing: false });
            });
    }

    onSelectTitle = (titleId) => {
        globals.selectedTitle = titleId;
        localStorage.setItem("selectedTitle", titleId);

        // Navigate to Home page for the selected title
        window.location.hash = `${Page.Home.id}-0`;
    };

    render() {
        const titlesDict = globals.loginData?.titles?.titles ?? {};
        const entries = Object.entries(titlesDict);
        const selected = globals.selectedTitle;

        return (
            <Container maxWidth="md" sx={{ paddingTop: 3, paddingBottom: 3 }}>
                <Paper elevation={1} sx={{ padding: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 2 }}>
                        <Typography variant="h6">Game Selection</Typography>

                        <Button
                            variant="outlined"
                            size="small"
                            onClick={this.onRefresh}
                            disabled={this.state.refreshing}
                            sx={{ marginLeft: "auto" }}
                        >
                            {this.state.refreshing ? <CircularProgress size={16} /> : "Refresh"}
                        </Button>
                    </Box>

                    {entries.length === 0 ? (
                        <Typography variant="body2" color="text.secondary">
                            No titles available.
                        </Typography>
                    ) : (
                        <List dense disablePadding>
                            {entries.map(([titleId, info]) => {
                                const display = (info?.title ?? info?.name ?? titleId).toString();
                                const secondary = info?.description ? info.description.toString() : titleId;
                                const isSelected = selected === titleId;

                                return (
                                    <ListItemButton
                                        key={titleId}
                                        selected={isSelected}
                                        onClick={() => this.onSelectTitle(titleId)}
                                    >
                                        <ListItemText primary={display} secondary={secondary} />
                                    </ListItemButton>
                                );
                            })}
                        </List>
                    )}
                </Paper>
            </Container>
        );
    }
}
